<template>
  <div class="block">
    <kst-input load-on-focus
      field="TypeID" :data="userData" :catalog="Catalog"
      :options="typeOptions"
    />
    <kst-input field="Name" :data="userData" :catalog="Catalog"/>
    <kst-input field="SKU" :data="userData" :catalog="Catalog"/>
    <kst-input field="Barcode" :data="userData" :catalog="Catalog"/>
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>

    <kst-output field="ImageSrc" :data="userData" :catalog="Catalog">
      <kst-image :is-local="userData.ImageIsLocal" :src="userData.ImageSrc"
        @input="handleImageInput" @delete="handleImageDelete"
      />
    </kst-output>

    <kst-input field="LimitQty" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../ItemCatalog.js";

export default {
  props: {
    userData: Object,
    typeOptions: Object
  },
  data: () => ({
    Catalog: Catalog
  }),
  methods: {
    handleImageInput(imgSrc, imgText) {
      this.userData.ImageSrc = imgSrc;
      this.userData.Image64 = imgText;
      this.userData.ImageIsLocal = true;
    },
    handleImageDelete() {
      this.userData.ImageSrc = "";
      this.userData.Image64 = "";
      this.userData.ImageIsLocal = true;
    }
  }
}
</script>